import PropTypes from 'prop-types';
import {
  useState,
  useEffect,
  useContext,
  createContext,
} from 'react';

const LazyFeatureBundleContext = createContext();
LazyFeatureBundleContext.displayName = 'LazyFeatureBundleContext';

export const useLazyFeatureBundle = () => useContext(LazyFeatureBundleContext);

export const LazyFeatureBundleProvider = ({ children }) => {
  const [domAnimation, setDomAnimation] = useState({});

  useEffect(() => {
    import('./features').then((res) => {
      setDomAnimation(res.default);
    });
  }, []);

  return (
    <LazyFeatureBundleContext.Provider value={domAnimation}>
      {children}
    </LazyFeatureBundleContext.Provider>
  );
};

LazyFeatureBundleProvider.propTypes = {
  children: PropTypes.node,
};
